import { Hero } from "@/features/home/sections/Hero/Hero";
import { QuickFacts } from "@/features/home/sections/QuickFacts/QuickFacts";
import { Audience } from "@/features/home/sections/Audience/Audience";
import { Pressure } from "@/features/home/sections/Pressure/Pressure";
import { AiFirst } from "@/features/home/sections/AiFirst/AiFirst";
import { MethodBanner } from "@/features/home/sections/MethodBanner/MethodBanner";
import { Offer } from "@/features/home/sections/Offer/Offer";
import { TestimonialCarousel } from "@/features/home/sections/TestimonialCarousel/TestimonialCarousel";
import { BeforeAfter } from "@/features/home/sections/BeforeAfter/BeforeAfter";
import { Deliverables } from "@/features/home/sections/Deliverables/Deliverables";
import { FounderClass } from "@/features/home/sections/FounderClass/FounderClass";
import { Mentors } from "@/features/home/sections/Mentors/Mentors";
import { Faq } from "@/features/home/sections/Faq/Faq";
import { WhatsAppHelp } from "@/features/home/sections/WhatsAppHelp/WhatsAppHelp";
import { Footer } from "@/features/home/sections/Footer/Footer";
import { StickyCta } from "@/features/home/components/StickyCta/StickyCta";
import { SignupModalProvider } from "@/features/signup/SignupModal";
import { Reveal } from "@/shared/components/Reveal";
import styles from "./HomePage.module.css";

export function HomePage() {
  return (
    <SignupModalProvider>
      <main id="home" className={styles.home}>
        <Hero />
        <Reveal>
          <QuickFacts />
        </Reveal>
        <Reveal>
          <Audience />
        </Reveal>
        <Reveal>
          <Pressure />
        </Reveal>
        <Reveal>
          <AiFirst />
        </Reveal>
        <Reveal className={styles.bannerOverlap}>
          <MethodBanner />
        </Reveal>
        <Reveal>
          <TestimonialCarousel />
        </Reveal>
        <Reveal>
          <Offer />
        </Reveal>
        <Reveal>
          <BeforeAfter />
        </Reveal>
        <Reveal>
          <Deliverables />
        </Reveal>
        <Reveal>
          <FounderClass />
        </Reveal>
        <Reveal>
          <Mentors />
        </Reveal>
        <Reveal>
          <Faq />
        </Reveal>
        <Reveal>
          <WhatsAppHelp />
        </Reveal>
        <Reveal>
          <Footer />
        </Reveal>
      </main>
      <StickyCta />
    </SignupModalProvider>
  );
}
